import SurveySelect from "./surveySelect.container";

export default SurveySelect;
